var $, localmed;

$ = window.jQuery;

localmed = require('./base');

require('./plugin');

require('./get-target');

require('./try-trigger');

$(document).on('click.dropdown.data-api', '[data-toggle="dropdown"]', function(event) {
  $(this).toggleDropdown();
  return false;
});

$.plugin('dropdown', {
  defaults: {
    activeClass: localmed.defaults.activeClass
  },
  init: function() {
    this.isOpen = false;
    return $(document).on('dropdown:open.dropdown', (function(_this) {
      return function(event) {
        return _this._onDropdownOpen(event);
      };
    })(this));
  },
  open: function() {
    if (this.isOpen) {
      return this;
    }
    this._isOpening = true;
    if (!this.element.tryTrigger('dropdown:open')) {
      this._isOpening = false;
      return this;
    }
    this.isOpen = true;
    this.element.addClass(this.options.activeClass).trigger('dropdown:opened');
    this._isOpening = false;
    return this;
  },
  close: function() {
    if (!this.isOpen || this._isOpening) {
      return this;
    }
    if (!this.element.tryTrigger('dropdown:close')) {
      return this;
    }
    this.isOpen = false;
    this.element.removeClass(this.options.activeClass).trigger('dropdown:closed');
    return this;
  },
  toggle: function() {
    if (this.isOpen) {
      return this.close();
    } else {
      return this.open();
    }
  },
  _onDropdownOpen: function(event) {
    return this.close();
  }
});

$.plugin('toggleDropdown', {
  defaults: {
    activeClass: localmed.defaults.activeClass
  },
  init: function() {
    this.target = this.element.getTarget() || this._getParentTarget(this.element);
    this.dropdown = this.target.getPlugin('dropdown');
    if (!this.dropdown) {
      this.dropdown = this.target.createPlugin('dropdown', this.options);
      this.target.on('dropdown:open.toggleDropdown', (function(_this) {
        return function(event) {
          return _this._onDropdownOpen(event);
        };
      })(this));
      return this.target.on('dropdown:closed.toggleDropdown', (function(_this) {
        return function(event) {
          return _this._onDropdownClose(event);
        };
      })(this));
    }
  },
  run: function() {
    return this.dropdown.toggle();
  },
  _getParentTarget: function() {
    var target;
    target = this.element.parent();
    if (target.length) {
      this.element.data('target', target);
    }
    return target;
  },
  _onDropdownOpen: function(event) {
    return this.element.addClass(this.options.activeClass);
  },
  _onDropdownClose: function(event) {
    return this.element.removeClass(this.options.activeClass);
  }
});
